import {useEffect, useState} from "react";

import {getProductStockListByGroup} from "../api/product-stock-list-by-group";

function useProductStockList(productGroupId, productDetails, showSpecials = false) {
    const [productStockList, setProductStockList] = useState(new Map());
    const [loadingStockList, setLoadingStockList] = useState(false);

    let productIdList = [];
    let productIdAndUnitList = [];
    if(Array.isArray(productDetails) && productDetails.length) {
        productIdList = productDetails.map((item) => item.id);
        productIdAndUnitList = productDetails.map((item) => {
            return {
                productCode: item.product_code,
                unitCode: item.unit_code,
            };
        });
    }

    const loadProductStockList = async (productIdList, productIdAndUnitList) => {
        setLoadingStockList(true);
        const stock = await getProductStockListByGroup(productIdList, productIdAndUnitList);
        setLoadingStockList(false);

        const stocksMap = new Map();
        stock.forEach((stock) => {
            stocksMap.set(`${stock.productCode}-${stock.unitCode}`, stock);
        });
        setProductStockList(stocksMap);
    };

    useEffect(() => {
        let ignore = false;
        if (showSpecials && !ignore && Array.isArray(productIdList) && productIdList.length) {
            loadProductStockList(productIdList, productIdAndUnitList);
        }

        return () => {
            ignore = true;
        }
    }, [productGroupId, productDetails]);

    return {
        productStockList,
        loadingStockList,
    };
}

export default useProductStockList;